module.exports = fox._r("images/welcome.png", __webpack_public_path__ + "images/welcome.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/welcome.png
// module id = 1140
// module chunks = 4